import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  baseUrl = environment.baseUrl;


  constructor(private http: HttpClient, private cookie: CookieService) { }

  sairService(): Observable<object> {
    window.localStorage.removeItem('usuario');
    window.localStorage.removeItem('clientes');
    window.localStorage.removeItem('permissoes');
    window.localStorage.removeItem('cliente');
    window.localStorage.removeItem('usuarioId');

    return this.http.post(`${this.baseUrl}logout`, null, { ...this.options, withCredentials: true });
  }

  async loginService(user: any) {
    const resultado = await this.http.post<any>(`${this.baseUrl}login`, user, { ...this.options, withCredentials: true }).toPromise();
    var cliente = localStorage.getItem('cliente')
    if (resultado && resultado.token) {
      window.localStorage.setItem('token', resultado.token);
      window.localStorage.setItem('clientes', resultado.clientes);
      window.localStorage.setItem('usuario', resultado.usuario);
      window.localStorage.setItem('permissoes', resultado.permissoes);
      window.localStorage.setItem('usuarioId', resultado.usuarioId);
      if (!cliente) {
        window.localStorage.setItem('cliente', resultado.clienteId[0]);
      }
      return true;
    }
    return false;
  }

  obterToken(): string {
    return window.localStorage.getItem('token') || '';
  }

  obterExpiracaoTokenCookie(): Date | null {
    const encodedExpiration = this.cookie.get('token_expiration');
    if (!encodedExpiration) {
      return null;
    }

    try {
      const expirationTimestamp = parseInt(atob(encodedExpiration), 10);
      if (isNaN(expirationTimestamp)) {
        return null;
      }
      const date = new Date(0);
      date.setUTCSeconds(expirationTimestamp);
      return date;
    } catch (e) {
      console.error('Erro ao decodificar expiração do token:', e);
      return null;
    }
  }

  obterValidadeToken(token: string): Date {
    const decoded: any = jwt_decode.default(token);

    if (decoded.exp === undefined) {
      return null!;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  tokenExpirado(token?: string): boolean {
    const cookieDate = this.obterExpiracaoTokenCookie();
    if (cookieDate) {
      return !(cookieDate.valueOf() > new Date().valueOf());
    }

    if (!token) {
      return true
    }

    const date = this.obterValidadeToken(token!);
    if (date === undefined) {
      return false;
    }

    return !(date.valueOf() > new Date().valueOf());
  }

  temUsuarioLogado() {
    const token = this.obterToken();
    const cookieDate = this.obterExpiracaoTokenCookie();

    if (cookieDate) {
      return cookieDate.valueOf() > new Date().valueOf();
    }

    if (!token) {
      return false;
    } else if (this.tokenExpirado(token)) {
      return false;
    } else {
      return true;
    }
  }

  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `bearer ${this.obterToken()}`,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers'
    })
  }
}
